import React, { Fragment } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { DisplayWeblinkPreviewDialog } from '../../components/DisplayWeblinkPreviewDialog';
import { AssetPicker } from '../../components/AssetPicker';
import { Status } from '../../components/Status';
import { AppHelper } from '../../helpers/AppHelper';
import { TableComponent } from '../../common/components/TableComponent';
import { Grid } from '@material-ui/core';
import { DragDropContext } from 'react-beautiful-dnd';
import { CampaignMediaDNDItems } from './CampaignMediaDNDItems';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { AppConfig } from '../../AppConfig';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { Toast } from '../../components/Toast';
import { MediaScheduleDialog } from '../../components/MediaScheduleDialog';
import { assetsFormAddition } from '../../data/data';
import { ScheduleCampaignDialog } from '../../components/ScheduleCampaignDialog';
import { CampaignHistoryDialog } from '../../components/CampaignHistoryDialog';

export class CampaignItems extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'CampaignItems'
    this.noAdd = true
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.itemId = this.props.match.params.id
    this.noTableHead = true
    if(this.props.match.path.includes('/ss-campaigns/')) {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('campaignsSelfServe'), to: this.baseRoute() + '/ss-campaigns' },
        { title: Helper.getString('media') },
      ]
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('campaigns'), to: this.baseRoute() + '/campaigns' },
        { title: Helper.getString('mediaAndDetails') }
      ]
    }
    this.entityAttrName = 'items'
    this.toFetch = [
      { method: 'GET', paths: ['campaigns', this.itemId], queryParams: { pb: 'fieldDefCampaignItems, fieldDef', resolveassets: true } },
      { method: 'GET', paths: ['miscs', 'assets'], queryParams: { orgId: this.orgId, pb: 'fieldDef', limit: 100, state: 'LIVE', iType: '_ALL' } },
      { method: 'GET', paths: ['miscs','layouts'], queryParams: { orgId: this.orgId, limit: 100, state: 'LIVE' } }
    ]
    if (this.options && this.options.pageForOrgType === 'PARTNER') {
      this.toFetch.push({ method: 'GET', paths: ['orgs', this.orgId] })
    }
    const listThumbnail = (current) => {
      if(!current) return ''
      if (current.iType === 'LAYOUT') {
        return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.icons, Styles.layoutIcons)} >LAYOUT</span>)
      } else if (current.iType === 'VIDEO') {
        return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, {_IMAGEFIT: false})
      } else if (current.iType === 'WEBLINK') {
        return (<i  alt={Helper.getString('assetImageAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >http</i>)
      } else if (current.iType === 'MEDIA') {
        return listThumbnail(this.item.__resolves.assetsById[current.contentName])
      } else if (current.iType === 'ACCUWEATHER') {
        return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.icons, Styles.layoutIcons, Styles.layoutIconsAw)} >{Helper.getString('weather')}</span>)
      } else if (current.iType === 'TEXT') {
        return (<i alt={Helper.getString('assetTextAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >text_snippet</i>)
      } else{
        return (
          AppUiHelper.itemImage({...current, _IMAGEFIT: false, image: current.iType === 'IMAGE' || current.iType === 'QRWEBLINK' ? current.content : undefined})
        )
      }
    }
    /* this.customFormComponents = {
      assetPicker: {
        props: { orgId: this.orgId, disabled:true },
        comp: AssetPicker
      }
    } */
    this.tableHeadersMap = {
      // Index: (current) => current.__index + 1,
      grabber: (current) => {
        return (
          <div className={css(Styles.displayGrabber)}>
            <img className={css(Styles.grabberImage)} src={require('../../assets/icons/grabber.svg')} />
          </div>
        )
      },
      Order: (current) => {
        return(
          <div className={css(Styles.displayMiddle)}>{current.order}</div>
        )
      },
      title: (current) => {
        return (
          <div className={css(Styles.thumbnailDetails)}>
            {listThumbnail(current)}
            <div>
              <div className={css(Styles.spanValue, Styles.title)}>{current.title}</div>
              <span className={css(Styles.spanValue)}>{
                current.iType === 'MEDIA' && this.item.__resolves && this.item.__resolves.assetsById[current.contentName]
                  ?
                  this.item.__resolves.assetsById[current.contentName].iType
                  :
                  current.iType
              }</span>
              <span> | </span>
              <span className={css(Styles.spanValue)}>{(current.assetsDetails && current.assetsDetails.durationSecs) ? parseFloat(current.assetsDetails.durationSecs).toFixed(2) : parseFloat(current.durationSecs).toFixed(2) } Sec</span>
            </div>
          </div>
        )
      },
      // Info: (current) => {
      //   return (
      //     <div>
      //       <span className={css(Styles.spanValue)}>{(current.assetsDetails && current.assetsDetails.durationSecs) ? current.assetsDetails.durationSecs : current.durationSecs} Sec</span>
      //     </div>
      //   )
      // },
      Status: (current) => {
        return (
          <Fragment>
            {(current.iType !== 'MEDIA' || (current.iType === 'MEDIA' && current.assetsDetails && current.assetsDetails.iType)) ? AppUiHelper.itemStatusContainer(current) : <span className={css(Styles.mediaDeleted)}>{Helper.getString('mediaDeleted')}</span>}
            {this.getMediaDisableBadge(
              (this.item &&
              this.item.__resolves &&
              this.item.__resolves.assetsById &&
              this.item.__resolves.assetsById[current.contentName]) ||
              (this.item &&
                this.item.__resolves &&
                this.item.__resolves.layoutsById &&
                this.item.__resolves.layoutsById[current.contentName])
              || null)}
          </Fragment>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.addNewLabel = 'Add Media'
    this.sourceTableId = 'media-items'
    this.droppableTableId = 'campaign-items'
    this.allowAccessToRoles = ['CAMPAIGNS']
  }

  getMediaDisableBadge(asset) {
    if (!asset) return;
    if (!asset.state) return;
    console.log('getMediaDisableBadge', asset.state)
    if (asset.state === 'DISABLED') return (
      <div className={css(Styles.mediaDisabledContainer)}>{AppUiHelper.chipDisabled(Helper.getString('mediaDisabled'))}</div>
    )
  }

  _getTotalDuration(__resolves, items) {
    let totalDurationInSeconds = 0
    items.forEach(i => {
      i.order = String(i.order || '0')
      let duration = 0
      if (i.iType === 'MEDIA' && __resolves.assetsById && __resolves.assetsById[i.contentName]) {
        i.assetsDetails = __resolves.assetsById[i.contentName]
        duration = Number(i.assetsDetails.durationSecs)
      } else if (i.iType === 'LAYOUT' && __resolves.layoutsById && __resolves.layoutsById[i.contentName]) {
        i.assetsDetails = __resolves.layoutsById[i.contentName]
        duration = Number(i.assetsDetails.durationSecs)
      } else {
        duration = Number(i.durationSecs)
      }
      if (isNaN(duration)) {
        duration = 0
      }
      totalDurationInSeconds += duration
    });
    return totalDurationInSeconds
  }

  _getEnabledItems(__resolves, items) {
    return items && items.filter(i => {
      if (i.state === 'DISABLED') return false

      const media =
        (__resolves && __resolves.assetsById && __resolves.assetsById[i.contentName]) ||
        (__resolves && __resolves.layoutsById && __resolves.layoutsById[i.contentName])

      if (media && media.state === 'DISABLED') return false

      return true
    })
  }

  onFetchSuccess(results) {
    if (this.options && this.options.pageForOrgType === 'PARTNER') this.org = results[2]
    this.formDefinition = results[0].fieldDefCampaignItems;
    this.formDefinitionCampaign = results[0].fieldDef;
    const options = {
      fieldKey: 'state',
      keyToReplace: 'LIVE',
      replaceWithValue: 'ENABLED',
    }
    const stateField = this.formDefinitionCampaign.steps[0].fields.find(i => i.key === 'state')
    stateField.options = stateField.options.filter(i => ['LIVE', 'DISABLED'].includes(i.key))
    this.formDefinition = AppHelper.changeFieldOptionLabel(this.formDefinition, options)
    // if (this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'MEDIA')) {
    //   this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'MEDIA').mediaPicker = true
    // }
    if (this.orgId !== 'PRODUCT') {
      const f = this.formDefinitionCampaign.steps[0].fields.find((i) => i.key === 'hrSpots')
      if(f) f.hide = true
    }
    this.item = results[0]
    this.pageTitle = this.item.title
    const items = this.item ? Helper.dictToArray(this.item.items) : []
    this._getTotalDuration(this.item.__resolves, items)
    const enabledItems = this._getEnabledItems(this.item.__resolves, items)
    const totalDurationInSeconds = this._getTotalDuration(this.item.__resolves, enabledItems)

    this.mediaItems = results[1]
    this.layoutItems = results[2]

    // Check and marge layout to assets
    if (this.mediaItems.items && this.layoutItems.items) {
      this.layoutItems.items.map((x) => x.iType = 'LAYOUT')
      this.layoutItems.items = this.layoutItems.items.filter(item => item.layoutType !== 'SL')
      this.mediaItems.items = this._concatAssetsAndLayoutAndSort(this.mediaItems.items, this.layoutItems.items)
    }

    this.mediaItems.items = this.mediaItems.items.filter(item => item.state !== 'DISABLED' && item.iType !== 'HDMI-IN')

    if (this.mediaItems && this.mediaItems.fieldDef && this.mediaItems.fieldDef.steps && this.mediaItems.fieldDef.steps[0] && this.mediaItems.fieldDef.steps[0].fields) {
      this.mediaItems.fieldDef.steps[0].fields.forEach(field => {
        if (field.key === 'iType' && Array.isArray(field.options)) {
          field.options = field.options.filter(option => option.key !== 'HDMI-IN')
        }
      })
    }
    // For Partner removed Accuwether and HDMI-IN
    if (this.options.pageForOrgType === 'PARTNER') {
      this.mediaItems.fieldDef.steps[0].fields.find(i => i.key === 'iType').options = this.mediaItems.fieldDef.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'HDMI-IN' && x.key !== 'ACCUWEATHER' && x.key !== 'TEXT')
      this.mediaItems.items = this.mediaItems.items.filter(item => item.iType !== 'ACCUWEATHER' && item.iType !== 'TEXT')
    }

    this.mediaItems.fieldDef = AppHelper.changeFieldOptionLabel(this.mediaItems.fieldDef, options)
    // Push New dateTimeStr Fields
    AppHelper.addScheduleFieldsToAssetsFormField(assetsFormAddition, this.mediaItems.fieldDef)
    this.formDefinitionMedia = {
      ...this.mediaItems.fieldDef,
      formType: 'add'
    }
    // -- START --
    this.formDefinitionMedia.steps[0].fields.map((x) => {
      if (x.condition && x.condition.value === 'IMAGE') {
        x.autoFillTitleKey = 'title'
      }
      if (x.condition && x.condition.value === 'VIDEO' && x.documentUpload) {
        x.autoFillField = 'durationSecs' // add generic
        x.autoFillVideoDuration = true
        x.autoFillTitleKey = 'title'
        x.maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
        x.maxWidthOrHeight = 1920
        x.fileSizeLimit = AppHelper.getMaxVideoFileSize(this.options, this.org)
        if ((this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') && this.org && AppHelper.hasFeature(this.org, 'LARGEVIDEO')) {
          x.maxWidthOrHeight = 4096 // 4k max res
        }
        // eslint-disable-next-line camelcase
        this.formDefinitionMedia.steps[0].fields.find(i => i.key === x.autoFillField).v_condition = { key: 'iType', value: 'VIDEO', type: 'disable' }
        // Change in label for video START ----
        AppHelper.attachVideoValidationLabel({
          formDefinition: this.formDefinitionMedia,
          maxWidthOrHeight: x.maxWidthOrHeight,
          maxVideoDuration: x.maxVideoDuration,
          fileSizeLimit: x.fileSizeLimit
        })
        // END ----
      }
    })
    // -- End --
    if (AppConfig.FEATURES_OFF.includes('ASSET_WEBLINK')) {
      this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options = this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'WEBLINK')
    }

    this.setState({
      items: Helper.sortAscending(items),
      mediaItems: Helper.dictToArray(this.mediaItems.items),
      cards:[
        {
          title: Helper.getString('Enabled Media'),
          value: enabledItems.length || '0',
          image: require('../../assets/icons/stats/media.svg')
        },
        {
          title: Helper.getString('mediaDuration'),
          value: AppHelper.formatDuration(totalDurationInSeconds * 1000),
          image: require('../../assets/icons/stats/duration.svg')
        }
      ],
      mediaModalAction:false,
      isDragEnabled: (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) ? false : true,
      mediaFilterValue: '_ALL'
    })
    this.formDefinition.steps[0].fields.map((x) => {
      if (x.condition && x.condition.value === 'IMAGE') {
        x.autoFillTitleKey = 'title'
      }
      if (x.condition && x.condition.value === 'VIDEO' && x.documentUpload) {
        x.autoFillField = 'durationSecs' // add generic
        x.autoFillVideoDuration = true
        x.autoFillTitleKey = 'title'
        x.maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
        x.maxWidthOrHeight = 1920
        x.fileSizeLimit = AppHelper.getMaxVideoFileSize(this.options, this.org)
        if ((this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') && this.org && AppHelper.hasFeature(this.org, 'LARGEVIDEO')) {
          x.maxWidthOrHeight = 4096 // 4k max res
        }
        // eslint-disable-next-line camelcase
        this.formDefinition.steps[0].fields.find(i => i.key === x.autoFillField).v_condition = { key: 'iType', value: 'VIDEO', type: 'disable' }
      }
    })
    this._addHeaderActionButtons()

    // Generate_options_from_iTypes
    const mediaFormOptions = this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options
    const newOptions = mediaFormOptions.map((option) => ({
      key: option.key,
      value: option.key
    })).concat(
      this.options.pageForOrgType === 'PARTNER' ? [
        { key: '_ALL', value: 'ALL' }
      ] : [
        { key: 'LAYOUT', value: 'LAYOUT' },
        { key: '_ALL', value: 'ALL' },
      ]
    )
    this.singlePickerFilter = newOptions || []
  }

  _addHeaderActionButtons() {
    const actions = []
    UiHelper.addActionButtonByRole(actions, this._campaignEditButton(this.item), this.allowAccessToRoles)
    if (!AppConfig.FEATURES_OFF.includes('CAMPAIGN_SCHEDULE') || AppHelper.hasFeature(this.org, 'REGVENUE')) { // Schedule Campaign --
      UiHelper.addActionButtonByRole(actions, this._scheduleCampaignButton(this.item), this.allowAccessToRoles)
    }
    if (this.orgId && !AppConfig.FEATURES_OFF.includes('BULK_ATTACH_DETACH_VENUE')) { // Display Attached venues & Attach Detach--
      UiHelper.addActionButtonByRole(actions, this._venueBulkAttachDetachButton(this.item), this.allowAccessToRoles)
    }
    UiHelper.addActionButtonByRole(actions, this._campaignHistoryButton(this.item), this.allowAccessToRoles)
    this.headerActions = actions
  }

  _campaignEditButton(current) {
    return {
      label: Helper.getString('edit'),
      icon: 'edit',
      onClick: () => {
        this.formDefinitionCampaign.formType = 'edit'
        Helper.populateFormDefinitionValues(this.formDefinitionCampaign, this.item)
        this.setState({ modalOpenTaskEdit: true })
      },
      type: 'icon',
      containerStyle: Styles.containerStyle,
      iconStyle: Styles.iconStyle,
      linkStyle: Styles.linkStyle,
      tooltip: 'Edit'
    }
  }

  _venueBulkAttachDetachButton(current) {
    return {
      label: Helper.getString('listVenues'),
      icon: 'storefront',
      type: 'icon',
      containerStyle: Styles.containerStyle,
      iconStyle: Styles.iconStyle,
      linkStyle: Styles.linkStyle,
      tooltip: Helper.getString('listVenues'),
      onClick: () => {
        this.props.history.push(this.baseRoute() + '/campaigns/' + current.id + '/screens')
      }
    }
  }

  _campaignHistoryButton(current) {
    return {
      label: Helper.getString('campaignHistory'),
      icon: 'track_changes',
      type: 'icon',
      containerStyle: Styles.containerStyle,
      iconStyle: Styles.iconStyle,
      linkStyle: Styles.linkStyle,
      tooltip: Helper.getString('campaignHistory'),
      onClick: () => {
        this.setState({ currentHistoryItem: current, showCampaignHistory: true })
      }
    }
  }

  _scheduleCampaignButton(current) {
    return {
      label: Helper.getString('scheduleCampaign'),
      icon: 'update',
      type: 'icon',
      containerStyle: Styles.containerStyle,
      iconStyle: Styles.iconStyle,
      linkStyle: Styles.linkStyle,
      tooltip: Helper.getString('scheduleCampaign'),
      onClick: () => {
        this.setState({ currentScheduleItem: current, showScheduleOptions: true })
      }
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    this.removeLayoutOption()
    // if(this.formDefinition.steps[0].fields.find(i => i.mediaPicker === true).assetsDetails) delete this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'MEDIA').assetsDetails
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', this.itemId]),
    });
  }

  onDelete(current) {
    // if (current.assetsDetails) {
    //   this.formDefinition.steps[0].fields.find(i => i.mediaPicker === true && i.value === current.assetsDetails.id).assetsDetails = current.assetsDetails
    // }
    this.addLayoutOption()
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'MEDIA').hide = true
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'IMAGE').hide = true
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'VIDEO').hide = true
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAttrName: 'items', entityAction: 'deleteAndReorder', id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', this.itemId]),
    });
  }

  onEdit(current) {
    this.formDefinition.steps[0].fields.find((i) => i.key === 'iType').disabled = true
    this.addLayoutOption()
    this.formDefinition.steps[0].fields.find(i => i.key === 'order').disabled = true
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'MEDIA').hide = true
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'IMAGE').hide = true
    this.formDefinition.steps[0].fields.find(i => i.condition && i.condition.value === 'VIDEO').hide = true
    // if (current.assetsDetails) {
    //   this.formDefinition.steps[0].fields.find(i => i.mediaPicker === true && i.value === current.assetsDetails.id).assetsDetails = current.assetsDetails
    // }
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', this.itemId]),
    });
  }

  addLayoutOption() {
    const iTypeField = this.formDefinition.steps[0].fields.find(
      (field) => field.key === 'iType'
    )
    if (iTypeField && Array.isArray(iTypeField.options)) {
      const hasLayout = iTypeField.options.some(
        (option) => option.key === 'LAYOUT'
      )
      if (!hasLayout) {
        iTypeField.options.push({
          key: 'LAYOUT',
          label: 'LAYOUT',
        })
      }
    }
  }

  removeLayoutOption() {
    const iTypeField = this.formDefinition.steps[0].fields.find(
      (field) => field.key === 'iType'
    )
    if (iTypeField && Array.isArray(iTypeField.options)) {
      iTypeField.options = iTypeField.options.filter(
        (option) => option.key !== 'LAYOUT'
      )
    }
  }

  renderAboveTable() {
    return (
      <Fragment>
        {this.renderScheduleDialog()}
        {/* Edit Campaign */}
        <DynamicFormDialog
          apiMethod={'PUT'}
          apiEndPoint={ApiHelper.makeUrlPath(['campaigns', this.itemId])}
          apiData={this.apiData}
          formDefinition={this.formDefinitionCampaign}
          isOpen={this.state.modalOpenTaskEdit}
          onClosed={() => this.setState({ modalOpenTaskEdit: false })}
          onCompleteAction={() => {
            this.setState({ modalOpenTaskEdit: false, items: [] })
            this.fetchItems()
          }} />
        {/* Schedule Campaign */}
        <ScheduleCampaignDialog
          current={this.state.currentScheduleItem}
          successCallback={() => { this.setState({ showScheduleOptions: false }); this.fetchItems() }}
          title={Helper.getString('scheduleCampaign')}
          isOpen={this.state.showScheduleOptions ? true : false}
          onClosed={() => this.setState({ showScheduleOptions: false })}
        />
        <CampaignHistoryDialog
          current={this.state.currentHistoryItem}
          title={Helper.getString('campaignHistory')}
          isOpen={this.state.showCampaignHistory ? true : false}
          onClosed={() => this.setState({ showCampaignHistory: false })}
        />
        <DynamicFormDialog
          selectedImageDimension={this._selectedImageDimension}
          customSubmit={this._customMediaUploadHandle}
          formDefinition={this.formDefinitionMedia}
          isOpen={this.state.mediaModalAction}
          onClosed={this._hideMediaAddModal}
          uploadLocation={this.orgId}
        ></DynamicFormDialog>
        {this.getToast()}
        { (this.state.preview || this.state.current) && (this.state.current.iType === 'IMAGE' || this.state.current.iType === 'QRWEBLINK' || this.state.current.iType === 'VIDEO') &&
          <DisplayPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            adLink={this.state.current.content}
            onClosed={() => this.setState({ preview: undefined })}
          />
        }
        { (this.state.preview || this.state.current) && this.state.current.iType === 'WEBLINK' &&
          <DisplayWeblinkPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            adLink={this.state.current.contentName}
            onClosed={() => this.setState({ preview: undefined })}
          />
        }
      </Fragment>
    )
  }

  onActions(current) {
    const actions = []
    if(this.isMediaScheduled(current)) UiHelper.addActionButtonByRole(actions, this.schedulePreview(current), [])
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    if(current && current.iType === 'IMAGE' || current && current.iType === 'QRWEBLINK' || current.iType === 'VIDEO') {
      UiHelper.addActionButtonByRole(actions, this.imageVideoPreview(current), [])
    } else if (current && current.assetsDetails && current.iType === 'MEDIA' && current.assetsDetails.iType !== 'ACCUWEATHER' && current.assetsDetails.iType !== 'TEXT') {
      UiHelper.addActionButtonByRole(actions, this.mediaPreview(current), [])
    }
    return actions
  }

  isMediaScheduled(current) {
    // Check assets data
    if (this.item && this.item.__resolves && this.item.__resolves.assetsById && this.item.__resolves.assetsById[current.contentName]) {
      const mediaInfo = this.item.__resolves.assetsById[current.contentName];
      if (mediaInfo && (mediaInfo.startStr || mediaInfo.endStr)) {
        return true
      }
    }else if (this.item && this.item.__resolves && this.item.__resolves.layoutsById && this.item.__resolves.layoutsById[current.contentName]) {
      const mediaInfo = this.item.__resolves.layoutsById[current.contentName];
      if (mediaInfo && (mediaInfo.startStr || mediaInfo.endStr)) {
        return true
      }
    }
    return  false
  }

  getScheduleTimes(current) {
    if (this.item && this.item.__resolves && this.item.__resolves.assetsById && this.item.__resolves.assetsById[current.contentName]) {
      return this.item.__resolves.assetsById[current.contentName]
    } else if (this.item && this.item.__resolves && this.item.__resolves.layoutsById && this.item.__resolves.layoutsById[current.contentName]) {
      return this.item.__resolves.layoutsById[current.contentName]
    }
    return {}
  }

  schedulePreview(current) {
    return (
      <Tooltip title='Schedule' placement='top-start' key={current.assetsDetails.id + 'Schedule'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className={'material-icons-outlined ' + css(Styles.scheduleActionIcon)}
            onClick={() => {
              this.displayScheduleModal(current);
            }}>update</i>
        </span>
      </Tooltip>
    )
  }

  displayScheduleModal(current) {
    this.scheduleData = this.getScheduleTimes(current)
    this.setState({ schedulesPreview: true, current: current.assetsDetails });
  }

  renderScheduleDialog() {
    return (
      <MediaScheduleDialog
        title={(this.scheduleData && this.scheduleData.title) ? this.scheduleData.title : Helper.getString('scheduleTitle')}
        isOpen={this.state.schedulesPreview}
        onClosed={() => this.setState({ schedulesPreview: false })}
        scheduleInfo={this.scheduleData}
      ></MediaScheduleDialog>
    )
  }

  imageVideoPreview(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  mediaPreview(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.assetsDetails.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current: current.assetsDetails }) }} />
        </span>
      </Tooltip>
    )
  }

  customSubmit(options) {
    const { formData, caller } = options
    const maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
    if (formData.iType === 'VIDEO' && Math.round(formData.durationSecs) > maxVideoDuration) {
      let errorMessage = Helper.getString('maxDurationVideo')
      errorMessage = errorMessage.replace('%second%',maxVideoDuration)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        message: errorMessage,
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'IMAGE' && (formData.durationSecs > 15 || formData.durationSecs < 5) && this.orgId !== 'PRODUCT') {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('maxDurationImage'),
        message: Helper.getString('maxDurationImage'),
        success: false,
        inProcess: false
      })
      return
    }
    ApiHelper.call({
      method: 'put', paths: ['campaigns', this.itemId],
      jsonBody: { ...formData }
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      } else {
        this.setState({ modalOpen: false })
        this.fetchItems()
        return
      }
    })
  }

  // Handle Drag
  handleOnDragStart = (start, provided) => {}
  handleOnDragEnd = (result) => {
    // Extract the destination and source from the result object
    const { destination, source } = result;

    // Return early if there's no destination (dropped outside a droppable) or source (no drag start)
    if (!destination || !source) return;

    // Check if the item was dropped within the same table but in a different position
    if (
      destination.droppableId === this.droppableTableId &&
      destination.droppableId === source.droppableId &&
      destination.index !== source.index
    ) {
      // Ensure the item exists at the source index
      if (!this.state.items[source.index]) return;

      // Disable dragging during the update
      this.setState({ isDragEnabled: false });

      // Create a new array of items and move the dragged item to the new position
      const updatedItems = Array.from(this.state.items);
      const [movedItem] = updatedItems.splice(source.index, 1);
      movedItem._loading = true; // Mark the item as loading
      updatedItems.splice(destination.index, 0, movedItem);

      // Update the state with the new order and trigger an update function
      this.setState({ items: updatedItems }, () => {
        const newIds = this.state.items.map((x) => x.id);
        this._updateOrderOfItems(newIds);
      });

      // Check if the item was moved from a different table (e.g., adding new media)
    } else if (
      destination.droppableId === this.droppableTableId &&
      source.droppableId === this.sourceTableId
    ) {
      // Ensure the media item exists at the source index
      const mediaItems = this.state.filteredMediaItems || this.state.mediaItems
      if (!mediaItems || mediaItems.length < (source.index + 1) || !mediaItems[source.index]) return

      // Disable dragging during the update
      this.setState({ isDragEnabled: false });

      // Add the new media item to the list
      const media = this.state.filteredMediaItems && this.state.filteredMediaItems.length > 0 ? this.state.filteredMediaItems[source.index] : this.state.mediaItems[source.index];

      // Generate a new order of items including the new media
      const existingIds = this.state.items.map((x) => x.id);
      const newIds = this._insertAtIndex(existingIds, destination.index, '_NEW');

      const iType = (media.layoutjson && media.layoutjson.sections) || (media.mediaType &&  media.mediaType === 'LAYOUT') ? 'LAYOUT' : 'MEDIA'
      // Prepare the parameters for adding and reordering the items
      const param = {
        entityAttrName: 'items',
        entityAction: 'addAndReorder',
        title: media.title,
        state: 'LIVE',
        durationSecs: media.durationSecs,
        iType: iType,
        contentName: media.id,
        _neworders: newIds,
      };

      // Create a new object, mainly for showing action, that media is being added
      const newObject = {
        _loading: true,
        id: Math.floor(Math.random() * 99999999),
        __index: Math.floor(Math.random() * 99999999),
      };

      // Insert the new media object into the items array and update the state
      const items = Array.from(this.state.items);
      items.splice(destination.index, 0, newObject);
      this.setState({ items });

      // Call the function to add the media and update the order of items
      this._addMediaAndUpdateOrderOfItems(param);
    }
  };

  _insertAtIndex = (array, index, content) => {
    const updatedArray = [...array];
    updatedArray.splice(index, 0, content);
    return updatedArray;
  };

  _addMediaAndUpdateOrderOfItems = async (param) => {
    const apiOptions = {
      method: 'PUT',
      paths: ['campaigns', this.itemId],
      jsonBody: { ...param }
    }
    try {
      const response = await ApiHelper.callAwait(apiOptions)
      this._refreshCampaignList()
    } catch (err) {
      this.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error'
      })
      this._refreshCampaignList()
    }
  }

  _refreshCampaignList = async () => {
    try {
      this.item = await ApiHelper.callAwait(this.toFetch[0])
      const items = this.item.items ? Helper.dictToArray(this.item.items) : []
      const enabledItems = this._getEnabledItems(this.item.__resolves, items)
      this._getTotalDuration(this.item.__resolves, items)
      const totalDurationInSeconds = this._getTotalDuration(this.item.__resolves, enabledItems)
      this.setState({
        items: Helper.sortAscending(items),
        cards: [
          {
            title: Helper.getString('enabledMedia'),
            value: enabledItems.length || '0',
            image: require('../../assets/icons/stats/media.svg')
          },
          {
            title: Helper.getString('mediaDuration'),
            value: AppHelper.formatDuration(totalDurationInSeconds * 1000),
            image: require('../../assets/icons/stats/duration.svg')
          }
        ],
        isDragEnabled: true
      })
    } catch (err) {
      this.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error',
        isDragEnabled: true
      })
    }
  }

  _updateOrderOfItems = async (ids) => {
    const apiOptions = {
      method: 'PUT',
      paths: ['campaigns', this.itemId],
      jsonBody: {
        entityAttrName: 'items',
        entityAction: 'reorder',
        _neworders: ids
      }
    }
    try {
      const response = await ApiHelper.callAwait(apiOptions)
      this._refreshCampaignList()
    } catch (err) {
      this.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error'
      })
      this._refreshCampaignList()
    }
  }

  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.message}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  _selectedImageDimension = (props) => {
    this.setState({ currentImageDimension: props })
  }

  _customMediaUploadHandle = async (options) => {
    const { formData, caller, formType } = options
    const maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
    if (formData.iType === 'VIDEO' && Math.round(formData.durationSecs) > maxVideoDuration) {
      let errorMessage = Helper.getString('maxDurationVideo')
      errorMessage = errorMessage.replace('%second%',maxVideoDuration)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        message: errorMessage,
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'IMAGE' && (formData.durationSecs > 15 || formData.durationSecs < 5) && this.orgId !== 'PRODUCT') {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('maxDurationImage'),
        message: Helper.getString('maxDurationImage'),
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'QRWEBLINK' && formData.orientation && this.state.currentImageDimension && this.state.currentImageDimension.width && this.state.currentImageDimension.height) {
      const imageOrientation = this.state.currentImageDimension.width > this.state.currentImageDimension.height ? 'LANDSCAPE' : 'PORTRAIT';
      if (imageOrientation !== formData.orientation.toUpperCase()) {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getString('imageOrientationMismatch'),
          message: Helper.getString('imageOrientationMismatch'),
          success: false,
          inProcess: false
        });
        return;
      }
    }
    formData.durationSecs = parseInt(formData.durationSecs)
    formData.orgId = this.orgId
    let apiOptions = {}
    if (formType === 'edit') {
      apiOptions = {
        method: 'PUT',
        paths: ['assets', this.actionData.currentId],
        jsonBody: { ...formData }
      }
    } else if (formType === 'add') {
      apiOptions = {
        method: 'POST',
        paths: ['assets', this.orgId],
        jsonBody: { ...formData }
      }
    }

    try {
      const response = await ApiHelper.callAwait(apiOptions)
      this.setState({ mediaFilterValue: '_ALL', userInput: '' }, () => {
        this._refreshMediaList()
      })
    } catch (err) {
      caller.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        success: false,
      })
    }
  }

  _concatAssetsAndLayoutAndSort = (list1, list2) => {
    list1 = list1.concat(list2)
    list1.sort((a, b) => new Date(b.createdTs) - new Date(a.createdTs))
    return list1
  }

  _refreshMediaList = async () => {
    try {
      this.mediaItems = await ApiHelper.callAwait(this.toFetch[1])
      this.mediaItems.items = this.mediaItems.items.filter(item => item.state !== 'DISABLED' && item.iType !== 'HDMI-IN')
      // For Partner removed Accuwether and HDMI-IN
      if (this.options.pageForOrgType === 'PARTNER') {
        this.mediaItems.items = this.mediaItems.items.filter(item => item.iType !== 'ACCUWEATHER' && item.iType !== 'TEXT')
      }
      // Append Layout
      if (this.mediaItems.items && this.layoutItems.items) {
        this.layoutItems.items.map((x) => x.iType = 'LAYOUT')
        this.layoutItems.items = this.layoutItems.items.filter(item => item.layoutType !== 'SL')
        this.mediaItems.items = this._concatAssetsAndLayoutAndSort(this.mediaItems.items, this.layoutItems.items)
      }
      const mediaItems_ = Helper.dictToArray(this.mediaItems.items)
      this.setState({
        mediaModalAction: false,
        mediaItems: mediaItems_,
        isDragEnabled: true,
        filteredMediaItems: null
      })
    } catch (err) {
      this.setState({
        mediaModalAction: false,
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error',
        isDragEnabled: true
      })
    }
  }

  _showMediaAddModal = () => {
    Helper.deleteFormDefinitionValues(this.formDefinitionMedia)
    this.setState({mediaModalAction:true})
  }

  _hideMediaAddModal = () => {
    this.setState({mediaModalAction:false})
  }

  onChangeSearchValue = (event) => {
    if (!event.target.value) {
      const setStateObj = { userInput: null }
      this.setState(setStateObj, this._handleSearchAction)
      return
    }
    this.setState({
      userInput : event.target.value && event.target.value.toLowerCase()
    })
  }

  callApiPromise = (options) => {
    return new Promise((resolve, reject) => {
      ApiHelper.call(options, (err, data) => {
        if (err) reject(err);
        else resolve(data);
      });
    });
  };

  _handleSearchAction = async (event) => {
    if (!this.state.userInput && !this.state.mediaFilterValue) {
      return
    }

    this.setState({ inProcessSearch: true });

    const queryParams = {};
    if (this.state.userInput) queryParams.query = this.state.userInput;
    queryParams.orgId = this.orgId;
    queryParams.state = 'LIVE';
    queryParams.pb = 'fieldDef'
    queryParams.iType = this.state.mediaFilterValue

    const apiOptions1 = {
      method: 'GET',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'assets'], queryParams),
    };

    const apiOptions2 = {
      method: 'GET',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'layouts'], queryParams),
    };

    try {
      // Call both APIs in parallel
      const [data1, data2] = await Promise.all([
        this.callApiPromise(apiOptions1),
        this.callApiPromise(apiOptions2)
      ]);

      if(this.state.mediaFilterValue === '_ALL' || this.state.mediaFilterValue === 'LAYOUT') {
        data2.items = data2.items.filter(item => item.layoutType !== 'SL')
      } else {
        data2.items = []
      }

      // Merge items
      let mergedItems = this._concatAssetsAndLayoutAndSort(data1.items || [], data2.items || [])

      mergedItems = mergedItems.filter(item =>
        item.state !== 'DISABLED' &&
        item.iType !== 'HDMI-IN' &&
        ( // Filter Accuwether if partner
          this.options.pageForOrgType !== 'PARTNER' ||
          item.iType !== 'ACCUWEATHER' ||
          item.iType !== 'TEXT'
        )
      );

      this.setState({
        filteredMediaItems: mergedItems,
        successMsg: '',
        errMsg: null,
        inProcessSearch: false,
      });

    } catch (err) {
      this.setState({
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error',
        filteredMediaItems: [],
        inProcessSearch: false,
      });
    }
  };


  _addMediaToTop = (props) => {
    if(!this.state.isDragEnabled) return;
    const params = {
      source: {
        index: props.index,
        droppableId: this.sourceTableId
      },
      destination: {
        droppableId: this.droppableTableId,
        index: 0
      },
    }
    this.handleOnDragEnd(params)
  }

  singlePickerHandler(e) {
    const value = e.target.value
    this.setState({
      mediaFilterValue: value
    })
  }

  renderTable() {
    // alert()
    if (!this.onTableValue) {
      return ''
    }
    return (
      <Grid container spacing={3} className={css(Styles.gridContainer)}>
        <Grid item key={'campaigns-item-table'} lg={7} xs={12} sm={6} md={7}>
          { this.state.cards && <Stats lg={6} items={this.state.cards}></Stats> }
          {/* <div className={css(Styles.tipText)}>{Helper.getString('dragTipMessage')}</div> */}
          <div className={`${css(Styles.scrollTable)} scrollTable`}
            style={
              this.state.items && this.state.items.length < 4
                ? { overflow: 'hidden' }
                : { overflow: 'auto' }
            }>
            <TableComponent
              tableHeaders={this.tableHeaders}
              noTableHead={this.noTableHead || false}
              onTableValue={this.onTableValue ? this.onTableValue.bind(this) : this.onTableValue}
              tableHeadersMap={this.tableHeadersMap}
              items={this.state.items}
              setItems={this.setItems}
              headerActions={this.headerActions} //Multi checkbox
              onActions={this.onActions.bind(this)}
              onMenuItems={this.onMenuItems && this.onMenuItems.bind(this)}
              nextPage={this.state.nextPage}
              nextPageState={this.state.nextPageState}
              onNext={this.onNext.bind(this)}
              emptyText={this.emptyText}
              cellWidths={this.cellWidths}
              displayCheckBoxTable={this.displayCheckBoxTable || false}
              checkBoxActions={this.checkBoxActions.bind(this)}
              isDragEnabled={this.state.isDragEnabled}
              droppableTableId={this.droppableTableId}
            />
          </div>
        </Grid>
        <Grid item key={'campaigns-media-table'} lg={5} xs={12} sm={6} md={5}>
          <CampaignMediaDNDItems
            isDropDisabled={true}
            inProcessSearch = {this.state.inProcessSearch}
            draggingItem={this.state.draggingItem || null}
            droppableTableId={this.sourceTableId}
            isDragEnabled={this.state.isDragEnabled}
            mediaItems={this.state.filteredMediaItems || this.state.mediaItems || []}
            mediaUploadHandle={!UiHelper.isUserHasRoles(this.allowAccessToRoles) ? null : this._showMediaAddModal}
            handleSearchAction={this._handleSearchAction}
            onChangeSearchValue={this.onChangeSearchValue}
            query={this.state.userInput}
            handleAddButton={!UiHelper.isUserHasRoles(this.allowAccessToRoles) ? null : this._addMediaToTop}
            singlePickerOptions={this.singlePickerFilter || []}
            singlePickerHandler={this.singlePickerHandler.bind(this)}
            singlePickerDefaultValue={this.state.mediaFilterValue}
          />
        </Grid>
      </Grid>
    )
  }
}

const Styles = StyleSheet.create({
  layoutIcons:{
    fontSize: '8px !important',
    fontWeight: 900,
    color: '#fff'
  },
  scrollTable:{
    // maxHeight: '62vh',
    height: window.innerHeight - 310,
    // overflow:'auto',
    marginTop: 20,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16
  },
  grabberImage:{
    width: 18,
    height: 18
  },
  actionIconImage:{
    width: 20,
    height: 20
  },
  displayGrabber:{
    paddingTop:6
  },
  displayMiddle:{
    // paddingTop:10
  },
  thumbnailDetails:{
    display:'flex',
    flexDirection: 'row',
    // flexWrap: 'wrap',
    alignItems: 'center'
  },
  title:{
    fontSize: 16,
    color: '#121212',
    maxWidth: '150px',
    textAlignLast: 'revert-layer',
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important'
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  icons:{
    // fontSize: 40,
    // color: 'lightgray',
    // marginRight: 12
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardStyle: {
    marginBottom:10
  },
  mediaDeleted: {
    color: '#ff0d0d'
  },
  tipText:{
    marginTop: 36,
    fontSize: 14,
    color: '#575757'
  },
  gridContainer:{
    marginBottom:0
  },
  scheduleTime: {
    fontSize: 12,
    maxWidth: 180
  },
  mediaDisabledContainer: {
    marginTop: 4
  },
  scheduleActionIcon: {
    color: '#2029f1c7'
  },
  layoutIconsAw: {
    fontSize: 7
  },
  containerStyle: {
    background: AppTheme.primaryColor
  },
  iconStyle: {
    color: '#fff !important'
  },
  linkStyle: {
    marginLeft: 0
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/CampaignItems.js